var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivityTypeLesson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DFF2F0",
    width: 27.94,
    height: 26.543,
    rx: 11.176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.659 13.284c-.023-.427.788-1.05 1.146-.815.358.235.87 1.677 1.172 3.347.323 1.789.534 4.952-.335 4.69-.425-.127-.359-1.29-.693-1.272-.334.017-.335.682-.723.553-.594-.198-.36-2.387-.438-4.042-.054-1.15-.116-2.2-.13-2.461zM13.837 6.16c1.185 0 4.356.974 6.688 1.947 1.431.597 2.622 1.035 2.622 1.714 0 .598-1.59 1.2-2.831 1.74-2.465 1.07-5.598 1.884-6.481 1.884-.894 0-4.686-1.049-7.16-2.134-1.199-.527-2.195-.978-2.195-1.483 0-.513 1.03-.925 2.196-1.466 2.346-1.09 5.884-2.202 7.161-2.202zm-5.811 7.302c1.397-.048 3.357 1.337 5.787 1.337 1.637 0 2.878-.54 3.977-.898.45-.146.951-.506 1.369-.298.418.207.314 1.079.314 2.005 0 .765-.134 1.616-.434 2.142-.656 1.15-2.789 1.737-5.614 1.737-2.824 0-4.578-.84-5.407-1.691-.328-.337-.599-1.12-.599-1.778 0-.934-.318-2.523.607-2.556z",
    fill: "#70C8BC"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTypeLesson);
export default __webpack_public_path__ + "static/media/activity-type-lesson.a290eeb90250d3c125729f175619e1a2.svg";
export { ForwardRef as ReactComponent };